
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://auth.analystx.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxjaXB6Z2VlZXhrb2xpbmVpb2RwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA1MDQ5MDAsImV4cCI6MjA1NjA4MDkwMH0.Amuh7y803dYR71KulwyIDQU75TBow6MdM5Yf-flgmQU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: localStorage,
    flowType: 'pkce',
    debug: true // Keep debugging enabled to help diagnose issues
  }
});
